module.exports = __webpack_public_path__ + "15f2befbb85baeef8bfceb06b261fe22.svg";